import api from "shared/infra/services/api";

export const useCreditCard = () => {
  const setCreditCardRequest = async (payload: any) => {
    const {
      number,
      name,
      expiry,
      cvc,
      phone,
      document,
      address_id,
      type_entity,
      document_type,
    } = payload;

    try {
      const response = await api.post("pay/card", {
        number,
        document,
        address_id,
        type_entity,
        cvv: cvc.replace("_", ""),
        holder_name: name,
        expiration_date: expiry,
        type: document_type,
        phone_number: phone,
      });

      return response.data;
    } catch (error: any) {
      const { data } = error.response;
      const { message, errors } = data;

      if (errors) {
        sessionStorage.setItem(
          "payment_error",
          JSON.stringify(Object.values(errors)),
        );
      } else {
        sessionStorage.setItem("payment_error", JSON.stringify(message));
      }
    }
    return null;
  };

  const removeCreditCardRequest = async (cardId: number) => {
    try {
      const response = await api.delete(`pay/card/${cardId}`);

      return response;
    } catch (error) {
      console.log("error -->", error);
    }
    return null;
  };

  return {
    setCreditCardRequest,
    removeCreditCardRequest,
  };
};
